const styleOverrides = {
    root: {
        width: '100%',
        input: {
            textOverflow: 'ellipsis',
        },
    },
};
const defaultProps = {
    variant: 'standard',
};
export default {
    styleOverrides,
    defaultProps,
};
